export class Decreased {
  private static _values: Decreased[] = [];
  private static _lookup: Map<number, Decreased> = new Map();

  static fromId(id: number) {
    const instance = Decreased._lookup.get(id);
    if (instance === undefined) {
      throw new Error('Not a valid Decreased.id: ' + id);
    }
    return instance;
  }

  static values(): Decreased[] {
    return [...Decreased._values];
  }

  // ---

  public readonly id: number;
  public readonly label: string;

  constructor(id: number, label: string) {
    this.id = id;
    this.label = label;
    Decreased._values.push(this);
    Decreased._lookup.set(id, this);
  }

  toJson(): { id: number; name: string } {
    return { id: this.id, name: this.label };
  }

  toString(): string {
    return '<Decreased: ' + this.id + ", label='" + this.label + "'>";
  }
}
